/* PS · Page tabs
   Turns [data-ps-page-tab] blocks inside page content into a tab rail. The copy stays
   in the Shopify page body, where the team edits it — each top-level block is a
   panel and its data-ps-page-tab is the label. Built for Returns & Exchanges, but any
   page can use it just by wrapping sections the same way. — Arnav, 17 Oct */
(function () {
  'use strict';

  function slug(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function build() {
    /* Scoped to data-ps-page-tab, NOT data-ps-tab: the PDP already uses
       data-ps-tab on its DESCRIPTION / FIT / FABRIC buttons to hold an index,
       and this script hijacked them, relabelling the lot "0 1 2 3". Sharing an
       attribute name across two tab systems was the whole bug. The filter is a
       second belt: never touch a node inside somebody else's tab UI.
       — Arnav, 19 Oct */
    var panels = [].slice.call(document.querySelectorAll('[data-ps-page-tab]'))
      .filter(function (el) { return !el.closest('[data-ps-tab]'); });
    if (panels.length < 2) return;
    var host = panels[0].parentNode;
    if (!host || host.dataset.psTabsBuilt) return;
    host.dataset.psTabsBuilt = '1';
    host.classList.add('ps-tabs');

    var rail = document.createElement('div');
    rail.className = 'ps-tabs__rail';
    rail.setAttribute('role', 'tablist');

    var buttons = panels.map(function (panel, i) {
      var label = panel.getAttribute('data-ps-page-tab');
      var key = slug(label);
      panel.id = 'ps-panel-' + key;
      panel.className += ' ps-tabs__panel';
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', 'ps-tab-' + key);
      panel.hidden = true;

      var b = document.createElement('button');
      b.type = 'button';
      b.id = 'ps-tab-' + key;
      b.className = 'ps-tabs__tab';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-controls', panel.id);
      b.setAttribute('aria-selected', 'false');
      b.tabIndex = -1;
      b.textContent = label;
      b.dataset.key = key;
      rail.appendChild(b);
      return b;
    });

    function select(i, moveFocus) {
      buttons.forEach(function (b, j) {
        var on = i === j;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        panels[j].hidden = !on;
      });
      if (moveFocus) buttons[i].focus();
    }

    buttons.forEach(function (b, i) {
      b.addEventListener('click', function () {
        select(i);
        /* replaceState, not a hash jump: switching tab shouldn't scroll the page,
           but the URL should still be shareable. */
        try { history.replaceState(null, '', '#' + b.dataset.key); } catch (e) {}
      });
      b.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % buttons.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + buttons.length) % buttons.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = buttons.length - 1;
        if (n === null) return;
        e.preventDefault();
        select(n, true);
      });
    });

    host.insertBefore(rail, panels[0]);

    var want = decodeURIComponent((location.hash || '').replace('#', ''));
    var start = 0;
    buttons.forEach(function (b, i) { if (b.dataset.key === want) start = i; });
    select(start);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
